import React from 'react';
import { useAtomValue } from 'jotai';
import { Navigate, useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';

import { batchViewAtom } from '_atoms/batch';

import CardBodyMarkdown from '_components/CardBodyMarkdown/CardBodyMarkdown';
import CardFooter from '_components/CardFooter/CardFooter';
import CardHeader from '_components/CardHeader/CardHeader';
import PageLoadingSpinner from '_components/PageLoadingSpinner/PageLoadingSpinner';

import './Welcome.css';

const Welcome = () => {
  const { isLoading, data, error } = useAtomValue(batchViewAtom);
  const navigate = useNavigate();

  if (isLoading) return <PageLoadingSpinner label="Retrieving your materials" />;
  if (error) throw error;

  // Null batchView data means the user isn't logged in -> navigate to the login page
  if (data === null) return <Navigate to={`/login`} replace={true}/>

  // No welcome data for the batch -> navigate to the overview page
  if (!data?.welcome) return <Navigate to={`/overview`} replace={true}/>

  /**
   * The action of the "continue" button depends on how many materials are being administered:
   * - When there's only 1 survey/material, navigate to that survey.
   * - When a batch has multiple surveys/materials, navigate to the overview page.
   */
  const clickHandler = () => {
    if (data?.materials?.length === 1) navigate(`/surveys/${data.materials[0].slug}`);
    else navigate('/overview');
  }

  return (
    <Container className="fade-in">
      <Card className="welcome">
        <CardHeader>
          {data?.welcome?.header || 'Welcome!'}
        </CardHeader>
        <CardBodyMarkdown>
          {data?.welcome?.body || 'Welcome to the survey! Please click the button below to continue.'}
        </CardBodyMarkdown>
        <CardFooter buttonLabel={data?.welcome?.buttonLabel || 'Continue'} onClick={clickHandler}/>
      </Card>
    </Container>
  );
}

export default Welcome;